interface IProp {
  EWorkSpace?: boolean;
  width?: number;
  height?: number;
}

export const RemoveIcon = ({ EWorkSpace, width = 16, height = 16 }: IProp) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.70615 17.2562L4.74365 16.2937L10.0374 11L4.74365 5.70624L5.70615 4.74374L10.9999 10.0375L16.2937 4.74374L17.2562 5.70624L11.9624 11L17.2562 16.2937L16.2937 17.2562L10.9999 11.9625L5.70615 17.2562Z"
        fill={EWorkSpace ? "#94A3B8" : "white"}
      />
    </svg>
  );
};

export const CancelIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M5 5L14 14" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M5 14L14 5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const RemoveGptIcon = () =>{
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="17" viewBox="0 0 12 17" fill="none">
  <path d="M10.7062 5.20625C11.0968 4.81563 11.0968 4.18125 10.7062 3.79063C10.3155 3.4 9.68115 3.4 9.29053 3.79063L5.9999 7.08438L2.70615 3.79375C2.31553 3.40313 1.68115 3.40313 1.29053 3.79375C0.899902 4.18438 0.899902 4.81875 1.29053 5.20938L4.58428 8.5L1.29365 11.7938C0.903027 12.1844 0.903027 12.8188 1.29365 13.2094C1.68428 13.6 2.31865 13.6 2.70928 13.2094L5.9999 9.91563L9.29365 13.2063C9.68428 13.5969 10.3187 13.5969 10.7093 13.2063C11.0999 12.8156 11.0999 12.1813 10.7093 11.7906L7.41553 8.5L10.7062 5.20625Z" fill="#94A3B8"/>
</svg>
  )
}
